import CheckboxTileGroupFieldOriginal, {
  type CheckboxTileGroupFieldProps as OriginalCheckboxTileGroupFieldProps,
} from '@axa-japan/design-system-react/CheckboxTileGroupField';

type CheckboxTileOptions = {
  checked?: boolean;
  disabled?: boolean;
} & OriginalCheckboxTileGroupFieldProps['options'][number];

export type CheckboxTileGroupFieldProps = Omit<OriginalCheckboxTileGroupFieldProps, 'options'> & {
  options: [CheckboxTileOptions, ...CheckboxTileOptions[]];
};

/**
 * This component is a workaround that wraps the axa design system CheckboxTileGroupField
 * to allow the "checked" prop on each checkbox option.
 * We will use that while this is not fixed on the design system side
 *
 * Should be removed if the following PR get released
 * https://github.axa.com/aljdevops/design-system-react/pull/260
 */
const CheckboxTileGroupField = (props: CheckboxTileGroupFieldProps) => {
  const { options, ...rest } = props;
  const optionsWithRefs = options.map((op) => {
    return {
      ...op,
      ref: (ele) => {
        if (ele) {
          ele.checked = op?.checked ?? false;
          ele.disabled = op?.disabled ?? false;
        }
      },
    };
  }) as [CheckboxTileOptions, ...CheckboxTileOptions[]];
  return <CheckboxTileGroupFieldOriginal {...{ ...rest, options: optionsWithRefs }}></CheckboxTileGroupFieldOriginal>;
};

export default CheckboxTileGroupField;
